/**
 * @Author  : Luo
 * @Time    : 2020/4/10 14:32
 * optimization axios
 */

'use strict'

import Vue from 'vue'
import axios from 'axios'
import _message from '../message/index'
import { setStorage } from '../components/common/common_js'

/**
 * ip of host（development or production）
 * @type {{development: string, production: string}}
 */

const HOST_IP = {
  'production': 'https://gfp1.api.pre.geetecho.com',
  'development': 'https://gfp1.api.test.geetecho.com'
}

const DEFAULT_METHOD = 'get'

const envModule = process.env.ENV_MODULE

// 取消多次请求
const CancelToken = axios.CancelToken
let cancelSource = CancelToken.source()

// 请求拦截（根据不同的返回状态码做相应的处理）
axios.interceptors.request.use(
  date => {
    return date
  },
  error => {
    if (error.status === 404) return _message.ERR_HTTP_MESSAGE_NO_EXITS
  }
)

// 回应拦截（根据不同的返回状态码做相应的处理）
axios.interceptors.response.use(
  date => {
    return date
  },
  error => {
    if (error.toString().search('401') >= 0) {
      return {status: 401, message: '认证令牌无效', error: error.toString()}
    }

    if (error.toString().search('405') >= 0) {
      return {status: 405, message: '方法错误', error: error.toString()}
    }

    if (error.toString().search('500') >= 0) {
      return {status: 500, message: '服务器错误或参数、接口错误，请仔细校对', error: error.toString()}
    }

    if (error.response.status === 404) return {status: 500, message: _message.ERR_HTTP_MESSAGE_NO_EXITS, error: error.toString()}
  }
)

const baseUrl = envModule && envModule === 'production' ? HOST_IP['production'] : HOST_IP['development']

const _Ajax = async (options, resolve, reject, executed) => {
  if (!options || !options.url) return _message.ERR_GET_URL
  if (!options || !options.method) options.method = DEFAULT_METHOD
  if (!options.params) options.params = {}
  if (!options || !options.baseUrl) options.baseUrl = baseUrl
  if (typeof options.clearCancelSource === 'undefined') options.clearCancelSource = false

  if (typeof options.timeout === 'undefined') options.timeout = 20000

  if (typeof resolve === 'undefined') resolve = () => {}
  if (typeof reject === 'undefined') reject = () => {}
  if (typeof executed === 'undefined') executed = () => {}

  let storage = setStorage
  const token = storage.getItem('token') ? storage.getItem('token') : ''

  let headerArr = {'Access-Control-Allow-Origin': '*'}

  if (token) {
    headerArr['Authorization'] = 'Token  ' + token
  }

  if (options.clearCancelSource) {
    clearCancelSource()
  }

  axios({
    baseURL: options.baseUrl,
    method: options.method,
    url: options.url,
    headers: headerArr,
    timeout: options.timeout,
    data: options.params,
    cancelToken: cancelSource.token
  })
    .then((data) => {
      if (data.status !== 200) {
        if (data.status === 500) {
          Vue.prototype.$notice({type: 'error', content: '数据错误，请联系管理员！'})
        }
      }
      resolve(data)
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log('request canceled', err, '-&&-', err.message)
      } else {
        reject(err)
      }
    })
    .then((data) => {
      executed(data)
    })

  // 取消请求
  if (typeof cancelSource === 'undefined') cancelSource.cancel('operation canceled.')
}

const clearCancelSource = () => {
  cancelSource = {}
}

const backLogin = (router) => {
  clearCancelSource()
  router.push(
    {
      path: '/login'
    }
  )
}

const logout = (router) => {
  if (setStorage.getItem('token')) {
    setStorage.clear()
  }
  backLogin(router)
}

const initLogin = (router, call) => {
  if (!setStorage.getItem('token')) {
    if (typeof call === 'undefined') call = () => {}
    call()
    setStorage.clear()
    backLogin(router)
  }
}

export {
  _Ajax,
  initLogin,
  logout
}



// WEBPACK FOOTER //
// ./src/api/_axios.js